import { FormikContextType, FormikValues, useFormikContext } from 'formik';
import React from 'react';

interface Props {
    children: (contexto: FormikContextType<FormikValues>) => React.ReactElement;
}

const Contexto = ({ children }: Props): React.ReactElement =>
{
    const contexto = useFormikContext<FormikValues>();

    return children(contexto);
}

export default Contexto;
